window.COUNTRY_GROUPS_2020_ITEMS = [
  {
    "CtryGrpLnkID": 424,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 71,
    "Ctry_Code": "AF",
    "Ctry_Name": "Afghanistan",
    "Ctry_Name_Fr": "Afghanistan"
  },
  {
    "CtryGrpLnkID": 425,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 1,
    "Ctry_Code": "BD",
    "Ctry_Name": "Bangladesh",
    "Ctry_Name_Fr": "Bangladesh"
  },
  {
    "CtryGrpLnkID": 426,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 243,
    "Ctry_Code": "CD",
    "Ctry_Name": "Congo Democratic Republic",
    "Ctry_Name_Fr": "Congo, République démocratique du"
  },
  {
    "CtryGrpLnkID": 427,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 65,
    "Ctry_Code": "ET",
    "Ctry_Name": "Ethiopia",
    "Ctry_Name_Fr": "Éthiopie"
  },
  {
    "CtryGrpLnkID": 428,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 14,
    "Ctry_Code": "GH",
    "Ctry_Name": "Ghana",
    "Ctry_Name_Fr": "Ghana"
  },
  {
    "CtryGrpLnkID": 429,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 16,
    "Ctry_Code": "HT",
    "Ctry_Name": "Haiti",
    "Ctry_Name_Fr": "Haïti"
  },
  {
    "CtryGrpLnkID": 430,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 57,
    "Ctry_Code": "IA",
    "Ctry_Name": "India",
    "Ctry_Name_Fr": "Inde"
  },
  {
    "CtryGrpLnkID": 432,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 20,
    "Ctry_Code": "KE",
    "Ctry_Name": "Kenya",
    "Ctry_Name_Fr": "Kenya"
  },
  {
    "CtryGrpLnkID": 433,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 22,
    "Ctry_Code": "LB",
    "Ctry_Name": "Liberia",
    "Ctry_Name_Fr": "Libéria"
  },
  {
    "CtryGrpLnkID": 434,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 23,
    "Ctry_Code": "MD",
    "Ctry_Name": "Madagascar",
    "Ctry_Name_Fr": "Madagascar"
  },
  {
    "CtryGrpLnkID": 435,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 24,
    "Ctry_Code": "MW",
    "Ctry_Name": "Malawi",
    "Ctry_Name_Fr": "Malawi"
  },
  {
    "CtryGrpLnkID": 436,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 25,
    "Ctry_Code": "ML",
    "Ctry_Name": "Mali",
    "Ctry_Name_Fr": "Mali"
  },
  {
    "CtryGrpLnkID": 437,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 61,
    "Ctry_Code": "MZ",
    "Ctry_Name": "Mozambique",
    "Ctry_Name_Fr": "Mozambique"
  },
  {
    "CtryGrpLnkID": 439,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 13,
    "Ctry_Code": "NP",
    "Ctry_Name": "Nepal",
    "Ctry_Name_Fr": "Népal"
  },
  {
    "CtryGrpLnkID": 440,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 30,
    "Ctry_Code": "NG",
    "Ctry_Name": "Nigeria",
    "Ctry_Name_Fr": "Nigéria"
  },
  {
    "CtryGrpLnkID": 441,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 31,
    "Ctry_Code": "PK",
    "Ctry_Name": "Pakistan",
    "Ctry_Name_Fr": "Pakistan"
  },
  {
    "CtryGrpLnkID": 442,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 35,
    "Ctry_Code": "RW",
    "Ctry_Name": "Rwanda",
    "Ctry_Name_Fr": "Rwanda"
  },
  {
    "CtryGrpLnkID": 443,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 36,
    "Ctry_Code": "SN",
    "Ctry_Name": "Senegal",
    "Ctry_Name_Fr": "Sénégal"
  },
  {
    "CtryGrpLnkID": 444,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 247,
    "Ctry_Code": "SS",
    "Ctry_Name": "South Sudan",
    "Ctry_Name_Fr": "Soudan du Sud"
  },
  {
    "CtryGrpLnkID": 445,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 39,
    "Ctry_Code": "TZ",
    "Ctry_Name": "Tanzania",
    "Ctry_Name_Fr": "Tanzanie"
  },
  {
    "CtryGrpLnkID": 446,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 44,
    "Ctry_Code": "UG",
    "Ctry_Name": "Uganda",
    "Ctry_Name_Fr": "Ouganda"
  },
  {
    "CtryGrpLnkID": 447,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 46,
    "Ctry_Code": "YE",
    "Ctry_Name": "Yemen",
    "Ctry_Name_Fr": "Yémen"
  },
  {
    "CtryGrpLnkID": 448,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 47,
    "Ctry_Code": "ZM",
    "Ctry_Name": "Zambia",
    "Ctry_Name_Fr": "Zambie"
  },
  {
    "CtryGrpLnkID": 449,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 52,
    "Ctry_Code": "BJ",
    "Ctry_Name": "Benin",
    "Ctry_Name_Fr": "Bénin"
  },
  {
    "CtryGrpLnkID": 450,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 50,
    "Ctry_Code": "BF",
    "Ctry_Name": "Burkina Faso",
    "Ctry_Name_Fr": "Burkina Faso"
  },
  {
    "CtryGrpLnkID": 451,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 7,
    "Ctry_Code": "CI",
    "Ctry_Name": "Cote d'Ivoire",
    "Ctry_Name_Fr": "Côte d'Ivoire"
  },
  {
    "CtryGrpLnkID": 452,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 67,
    "Ctry_Code": "GN",
    "Ctry_Name": "Guinea",
    "Ctry_Name_Fr": "Guinée"
  },
  {
    "CtryGrpLnkID": 454,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 68,
    "Ctry_Code": "MR",
    "Ctry_Name": "Mauritania",
    "Ctry_Name_Fr": "Mauritanie"
  },
  {
    "CtryGrpLnkID": 455,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 29,
    "Ctry_Code": "NI",
    "Ctry_Name": "Niger",
    "Ctry_Name_Fr": "Niger"
  },
  {
    "CtryGrpLnkID": 457,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 41,
    "Ctry_Code": "TG",
    "Ctry_Name": "Togo",
    "Ctry_Name_Fr": "Togo"
  },
  {
    "CtryGrpLnkID": 458,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 34,
    "Ctry_Code": "PH",
    "Ctry_Name": "Philippines",
    "Ctry_Name_Fr": "Philippines"
  },
  {
    "CtryGrpLnkID": 459,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 71,
    "Ctry_Code": "AF",
    "Ctry_Name": "Afghanistan",
    "Ctry_Name_Fr": "Afghanistan"
  },
  {
    "CtryGrpLnkID": 460,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 1,
    "Ctry_Code": "BD",
    "Ctry_Name": "Bangladesh",
    "Ctry_Name_Fr": "Bangladesh"
  },
  {
    "CtryGrpLnkID": 461,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 243,
    "Ctry_Code": "CD",
    "Ctry_Name": "Congo Democratic Republic",
    "Ctry_Name_Fr": "Congo, République démocratique du"
  },
  {
    "CtryGrpLnkID": 462,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 65,
    "Ctry_Code": "ET",
    "Ctry_Name": "Ethiopia",
    "Ctry_Name_Fr": "Éthiopie"
  },
  {
    "CtryGrpLnkID": 463,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 14,
    "Ctry_Code": "GH",
    "Ctry_Name": "Ghana",
    "Ctry_Name_Fr": "Ghana"
  },
  {
    "CtryGrpLnkID": 464,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 16,
    "Ctry_Code": "HT",
    "Ctry_Name": "Haiti",
    "Ctry_Name_Fr": "Haïti"
  },
  {
    "CtryGrpLnkID": 465,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 57,
    "Ctry_Code": "IA",
    "Ctry_Name": "India",
    "Ctry_Name_Fr": "Inde"
  },
  {
    "CtryGrpLnkID": 466,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 17,
    "Ctry_Code": "ID",
    "Ctry_Name": "Indonesia",
    "Ctry_Name_Fr": "Indonésie"
  },
  {
    "CtryGrpLnkID": 467,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 20,
    "Ctry_Code": "KE",
    "Ctry_Name": "Kenya",
    "Ctry_Name_Fr": "Kenya"
  },
  {
    "CtryGrpLnkID": 468,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 22,
    "Ctry_Code": "LB",
    "Ctry_Name": "Liberia",
    "Ctry_Name_Fr": "Libéria"
  },
  {
    "CtryGrpLnkID": 469,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 23,
    "Ctry_Code": "MD",
    "Ctry_Name": "Madagascar",
    "Ctry_Name_Fr": "Madagascar"
  },
  {
    "CtryGrpLnkID": 470,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 24,
    "Ctry_Code": "MW",
    "Ctry_Name": "Malawi",
    "Ctry_Name_Fr": "Malawi"
  },
  {
    "CtryGrpLnkID": 471,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 25,
    "Ctry_Code": "ML",
    "Ctry_Name": "Mali",
    "Ctry_Name_Fr": "Mali"
  },
  {
    "CtryGrpLnkID": 472,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 61,
    "Ctry_Code": "MZ",
    "Ctry_Name": "Mozambique",
    "Ctry_Name_Fr": "Mozambique"
  },
  {
    "CtryGrpLnkID": 473,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 64,
    "Ctry_Code": "MM",
    "Ctry_Name": "Myanmar",
    "Ctry_Name_Fr": "Myanmar"
  },
  {
    "CtryGrpLnkID": 474,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 13,
    "Ctry_Code": "NP",
    "Ctry_Name": "Nepal",
    "Ctry_Name_Fr": "Népal"
  },
  {
    "CtryGrpLnkID": 475,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 30,
    "Ctry_Code": "NG",
    "Ctry_Name": "Nigeria",
    "Ctry_Name_Fr": "Nigéria"
  },
  {
    "CtryGrpLnkID": 476,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 31,
    "Ctry_Code": "PK",
    "Ctry_Name": "Pakistan",
    "Ctry_Name_Fr": "Pakistan"
  },
  {
    "CtryGrpLnkID": 477,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 35,
    "Ctry_Code": "RW",
    "Ctry_Name": "Rwanda",
    "Ctry_Name_Fr": "Rwanda"
  },
  {
    "CtryGrpLnkID": 478,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 36,
    "Ctry_Code": "SN",
    "Ctry_Name": "Senegal",
    "Ctry_Name_Fr": "Sénégal"
  },
  {
    "CtryGrpLnkID": 479,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 247,
    "Ctry_Code": "SS",
    "Ctry_Name": "South Sudan",
    "Ctry_Name_Fr": "Soudan du Sud"
  },
  {
    "CtryGrpLnkID": 480,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 39,
    "Ctry_Code": "TZ",
    "Ctry_Name": "Tanzania",
    "Ctry_Name_Fr": "Tanzanie"
  },
  {
    "CtryGrpLnkID": 481,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 44,
    "Ctry_Code": "UG",
    "Ctry_Name": "Uganda",
    "Ctry_Name_Fr": "Ouganda"
  },
  {
    "CtryGrpLnkID": 482,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 46,
    "Ctry_Code": "YE",
    "Ctry_Name": "Yemen",
    "Ctry_Name_Fr": "Yémen"
  },
  {
    "CtryGrpLnkID": 483,
    "CtryGrpID": 3,
    "CtryGrpName": "USAID MCH Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’USAID SMI",
    "Ctry_ID": 47,
    "Ctry_Code": "ZM",
    "Ctry_Name": "Zambia",
    "Ctry_Name_Fr": "Zambie"
  },
  {
    "CtryGrpLnkID": 484,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 76,
    "Ctry_Code": "AO",
    "Ctry_Name": "Angola",
    "Ctry_Name_Fr": "Angola"
  },
  {
    "CtryGrpLnkID": 485,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 52,
    "Ctry_Code": "BJ",
    "Ctry_Name": "Benin",
    "Ctry_Name_Fr": "Bénin"
  },
  {
    "CtryGrpLnkID": 486,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 50,
    "Ctry_Code": "BF",
    "Ctry_Name": "Burkina Faso",
    "Ctry_Name_Fr": "Burkina Faso"
  },
  {
    "CtryGrpLnkID": 487,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 64,
    "Ctry_Code": "MM",
    "Ctry_Name": "Myanmar",
    "Ctry_Name_Fr": "Myanmar"
  },
  {
    "CtryGrpLnkID": 488,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 63,
    "Ctry_Code": "KH",
    "Ctry_Name": "Cambodia",
    "Ctry_Name_Fr": "Cambodge"
  },
  {
    "CtryGrpLnkID": 489,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 4,
    "Ctry_Code": "CM",
    "Ctry_Name": "Cameroon",
    "Ctry_Name_Fr": "Cameroun"
  },
  {
    "CtryGrpLnkID": 490,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 7,
    "Ctry_Code": "CI",
    "Ctry_Name": "Cote d'Ivoire",
    "Ctry_Name_Fr": "Côte d'Ivoire"
  },
  {
    "CtryGrpLnkID": 491,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 243,
    "Ctry_Code": "CD",
    "Ctry_Name": "Congo Democratic Republic",
    "Ctry_Name_Fr": "Congo, République démocratique du"
  },
  {
    "CtryGrpLnkID": 492,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 65,
    "Ctry_Code": "ET",
    "Ctry_Name": "Ethiopia",
    "Ctry_Name_Fr": "Éthiopie"
  },
  {
    "CtryGrpLnkID": 493,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 14,
    "Ctry_Code": "GH",
    "Ctry_Name": "Ghana",
    "Ctry_Name_Fr": "Ghana"
  },
  {
    "CtryGrpLnkID": 494,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 67,
    "Ctry_Code": "GN",
    "Ctry_Name": "Guinea",
    "Ctry_Name_Fr": "Guinée"
  },
  {
    "CtryGrpLnkID": 495,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 20,
    "Ctry_Code": "KE",
    "Ctry_Name": "Kenya",
    "Ctry_Name_Fr": "Kenya"
  },
  {
    "CtryGrpLnkID": 496,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 22,
    "Ctry_Code": "LB",
    "Ctry_Name": "Liberia",
    "Ctry_Name_Fr": "Libéria"
  },
  {
    "CtryGrpLnkID": 497,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 23,
    "Ctry_Code": "MD",
    "Ctry_Name": "Madagascar",
    "Ctry_Name_Fr": "Madagascar"
  },
  {
    "CtryGrpLnkID": 498,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 24,
    "Ctry_Code": "MW",
    "Ctry_Name": "Malawi",
    "Ctry_Name_Fr": "Malawi"
  },
  {
    "CtryGrpLnkID": 499,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 25,
    "Ctry_Code": "ML",
    "Ctry_Name": "Mali",
    "Ctry_Name_Fr": "Mali"
  },
  {
    "CtryGrpLnkID": 500,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 61,
    "Ctry_Code": "MZ",
    "Ctry_Name": "Mozambique",
    "Ctry_Name_Fr": "Mozambique"
  },
  {
    "CtryGrpLnkID": 501,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 29,
    "Ctry_Code": "NI",
    "Ctry_Name": "Niger",
    "Ctry_Name_Fr": "Niger"
  },
  {
    "CtryGrpLnkID": 502,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 30,
    "Ctry_Code": "NG",
    "Ctry_Name": "Nigeria",
    "Ctry_Name_Fr": "Nigéria"
  },
  {
    "CtryGrpLnkID": 503,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 35,
    "Ctry_Code": "RW",
    "Ctry_Name": "Rwanda",
    "Ctry_Name_Fr": "Rwanda"
  },
  {
    "CtryGrpLnkID": 504,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 36,
    "Ctry_Code": "SN",
    "Ctry_Name": "Senegal",
    "Ctry_Name_Fr": "Sénégal"
  },
  {
    "CtryGrpLnkID": 505,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 208,
    "Ctry_Code": "SL",
    "Ctry_Name": "Sierra Leone",
    "Ctry_Name_Fr": "Sierra Leone"
  },
  {
    "CtryGrpLnkID": 506,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 39,
    "Ctry_Code": "TZ",
    "Ctry_Name": "Tanzania",
    "Ctry_Name_Fr": "Tanzanie"
  },
  {
    "CtryGrpLnkID": 507,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 40,
    "Ctry_Code": "TH",
    "Ctry_Name": "Thailand",
    "Ctry_Name_Fr": "Thaïlande"
  },
  {
    "CtryGrpLnkID": 508,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 44,
    "Ctry_Code": "UG",
    "Ctry_Name": "Uganda",
    "Ctry_Name_Fr": "Ouganda"
  },
  {
    "CtryGrpLnkID": 509,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 47,
    "Ctry_Code": "ZM",
    "Ctry_Name": "Zambia",
    "Ctry_Name_Fr": "Zambie"
  },
  {
    "CtryGrpLnkID": 510,
    "CtryGrpID": 4,
    "CtryGrpName": "President's Malaria Initiative (PMI) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires de l’initiative présidentielle contre le paludisme",
    "Ctry_ID": 48,
    "Ctry_Code": "ZW",
    "Ctry_Name": "Zimbabwe",
    "Ctry_Name_Fr": "Zimbabwe"
  },
  {
    "CtryGrpLnkID": 511,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 20,
    "Ctry_Code": "KE",
    "Ctry_Name": "Kenya",
    "Ctry_Name_Fr": "Kenya"
  },
  {
    "CtryGrpLnkID": 512,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 160,
    "Ctry_Code": "LS",
    "Ctry_Name": "Lesotho",
    "Ctry_Name_Fr": "Lesotho"
  },
  {
    "CtryGrpLnkID": 513,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 24,
    "Ctry_Code": "MW",
    "Ctry_Name": "Malawi",
    "Ctry_Name_Fr": "Malawi"
  },
  {
    "CtryGrpLnkID": 514,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 39,
    "Ctry_Code": "TZ",
    "Ctry_Name": "Tanzania",
    "Ctry_Name_Fr": "Tanzanie"
  },
  {
    "CtryGrpLnkID": 515,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 44,
    "Ctry_Code": "UG",
    "Ctry_Name": "Uganda",
    "Ctry_Name_Fr": "Ouganda"
  },
  {
    "CtryGrpLnkID": 516,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 47,
    "Ctry_Code": "ZM",
    "Ctry_Name": "Zambia",
    "Ctry_Name_Fr": "Zambie"
  },
  {
    "CtryGrpLnkID": 517,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 48,
    "Ctry_Code": "ZW",
    "Ctry_Name": "Zimbabwe",
    "Ctry_Name_Fr": "Zimbabwe"
  },
  {
    "CtryGrpLnkID": 518,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 7,
    "Ctry_Code": "CI",
    "Ctry_Name": "Cote d'Ivoire",
    "Ctry_Name_Fr": "Côte d'Ivoire"
  },
  {
    "CtryGrpLnkID": 519,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 3,
    "Ctry_Code": "BT",
    "Ctry_Name": "Botswana",
    "Ctry_Name_Fr": "Botswana"
  },
  {
    "CtryGrpLnkID": 522,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 220,
    "Ctry_Code": "SZ",
    "Ctry_Name": "Eswatini",
    "Ctry_Name_Fr": "Swaziland"
  },
  {
    "CtryGrpLnkID": 523,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 16,
    "Ctry_Code": "HT",
    "Ctry_Name": "Haiti",
    "Ctry_Name_Fr": "Haïti"
  },
  {
    "CtryGrpLnkID": 524,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 35,
    "Ctry_Code": "RW",
    "Ctry_Name": "Rwanda",
    "Ctry_Name_Fr": "Rwanda"
  },
  {
    "CtryGrpLnkID": 525,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 28,
    "Ctry_Code": "NM",
    "Ctry_Name": "Namibia",
    "Ctry_Name_Fr": "Namibie"
  },
  {
    "CtryGrpLnkID": 526,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 76,
    "Ctry_Code": "AO",
    "Ctry_Name": "Angola",
    "Ctry_Name_Fr": "Angola"
  },
  {
    "CtryGrpLnkID": 527,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 51,
    "Ctry_Code": "BU",
    "Ctry_Name": "Burundi",
    "Ctry_Name_Fr": "Burundi"
  },
  {
    "CtryGrpLnkID": 528,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 4,
    "Ctry_Code": "CM",
    "Ctry_Name": "Cameroon",
    "Ctry_Name_Fr": "Cameroun"
  },
  {
    "CtryGrpLnkID": 529,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 243,
    "Ctry_Code": "CD",
    "Ctry_Name": "Congo Democratic Republic",
    "Ctry_Name_Fr": "Congo, République démocratique du"
  },
  {
    "CtryGrpLnkID": 530,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 8,
    "Ctry_Code": "DR",
    "Ctry_Name": "Dominican Republic",
    "Ctry_Name_Fr": "Dominicaine, République"
  },
  {
    "CtryGrpLnkID": 531,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 65,
    "Ctry_Code": "ET",
    "Ctry_Name": "Ethiopia",
    "Ctry_Name_Fr": "Éthiopie"
  },
  {
    "CtryGrpLnkID": 532,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 61,
    "Ctry_Code": "MZ",
    "Ctry_Name": "Mozambique",
    "Ctry_Name_Fr": "Mozambique"
  },
  {
    "CtryGrpLnkID": 533,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 30,
    "Ctry_Code": "NG",
    "Ctry_Name": "Nigeria",
    "Ctry_Name_Fr": "Nigéria"
  },
  {
    "CtryGrpLnkID": 534,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 55,
    "Ctry_Code": "ZA",
    "Ctry_Name": "South Africa",
    "Ctry_Name_Fr": "Afrique du Sud"
  },
  {
    "CtryGrpLnkID": 535,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 56,
    "Ctry_Code": "VN",
    "Ctry_Name": "Vietnam",
    "Ctry_Name_Fr": "Vietnam"
  },
  {
    "CtryGrpLnkID": 536,
    "CtryGrpID": 5,
    "CtryGrpName": "The U.S. President’s Emergency Plan for AIDS Relief (PEPFAR) Priority Countries",
    "CtryGrpName_fr": "Pays prioritaires du plan présidentiel d’urgence pour la lutte contre le SIDA",
    "Ctry_ID": 230,
    "Ctry_Code": "UA",
    "Ctry_Name": "Ukraine",
    "Ctry_Name_Fr": "Ukraine"
  },
  {
    "CtryGrpLnkID": 537,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 76,
    "Ctry_Code": "AO",
    "Ctry_Name": "Angola",
   "Ctry_Name_Fr": "Angola"
  },
  {
    "CtryGrpLnkID": 538,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 51,
    "Ctry_Code": "BU",
    "Ctry_Name": "Burundi",
    "Ctry_Name_Fr": "Burundi"
  },
  {
    "CtryGrpLnkID": 539,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 63,
    "Ctry_Code": "KH",
    "Ctry_Name": "Cambodia",
    "Ctry_Name_Fr": "Cambodge"
  },
  {
    "CtryGrpLnkID": 540,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 4,
    "Ctry_Code": "CM",
    "Ctry_Name": "Cameroon",
    "Ctry_Name_Fr": "Cameroun"
  },
  {
    "CtryGrpLnkID": 541,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 10,
    "Ctry_Code": "EG",
    "Ctry_Name": "Egypt",
    "Ctry_Name_Fr": "Égypte"
  },
  {
    "CtryGrpLnkID": 542,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 15,
    "Ctry_Code": "GU",
    "Ctry_Name": "Guatemala",
    "Ctry_Name_Fr": "Guatemala"
  },
  {
    "CtryGrpLnkID": 543,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 18,
    "Ctry_Code": "JO",
    "Ctry_Name": "Jordan",
    "Ctry_Name_Fr": "Jordanie"
  },
  {
    "CtryGrpLnkID": 544,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 208,
    "Ctry_Code": "SL",
    "Ctry_Name": "Sierra Leone",
    "Ctry_Name_Fr": "Sierra Leone"
  },
  {
    "CtryGrpLnkID": 545,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 117,
    "Ctry_Code": "TL",
    "Ctry_Name": "Timor-Leste",
    "Ctry_Name_Fr": "Timor-Est"
  },
  {
    "CtryGrpLnkID": 546,
    "CtryGrpID": 1,
    "CtryGrpName": "USAID FP/RH Recipient Countries",
    "CtryGrpName_fr": "Pays bénéficiaires de l’USAID PF/SR",
    "Ctry_ID": 48,
    "Ctry_Code": "ZW",
    "Ctry_Name": "Zimbabwe",
    "Ctry_Name_Fr": "Zimbabwe"
  },
];